// extracted by mini-css-extract-plugin
export default {"List":"s1c6AV_wB0GJPWpMnN5y","horizontal":"lvHTBdWirhK5K2Dm9PbZ"};